import Vue from 'vue'
import Router from 'vue-router'
import HomePage from '@/views/HomePage'
import Airports from '@/views/Airports'
import Faq from '@/views/Faq'
import Rates from '@/views/Rates'
import Login from '@/views/Login'
import Contacts from '@/views/Contacts'
import Rules from '@/views/Rules'
import MediaCenter from '@/views/MediaCenter'
import About from '@/views/About'
import News from '@/views/News'
import NewsInner from '@/views/NewsInner'
import Brand from '@/views/Brand'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'HomePage',
      component: HomePage,
      meta: {
        transparentHeader: true
      }
    },
    {
      path: '/airports',
      name: 'Airports',
      component: Airports,
      meta: {
        breadcrumb: [
          { name: 'Главная', link: '/' },
          { name: 'Аэропорты' }
        ]
      }
    },
    {
      path: '/faq',
      name: 'Faq',
      component: Faq,
      meta: {
        breadcrumb: [
          { name: 'Главная', link: '/' },
          { name: 'Часто задаваемые вопросы' }
        ]
      }
    },
    {
      path: '/rates',
      name: 'Rates',
      component: Rates,
      meta: {
        breadcrumb: [
          { name: 'Главная', link: '/' },
          { name: 'Тарифы' }
        ]
      }
    },
    {
      path: '/login',
      name: 'Login',
      component: Login,
      meta: {
        breadcrumb: [
          { name: 'Главная', link: '/' },
          { name: 'Вход' }
        ]
      }
    },
    {
      path: '/contacts',
      name: 'Contacts',
      component: Contacts,
      meta: {
        breadcrumb: [
          { name: 'Главная', link: '/' },
          { name: 'Контакты' }
        ]
      }
    },
    {
      path: '/rules',
      name: 'Rules',
      component: Rules,
      meta: {
        breadcrumb: [
          { name: 'Главная', link: '/' },
          { name: 'Правила' }
        ]
      }
    },
    {
      path: '/mediacenter',
      name: 'MediaCenter',
      component: MediaCenter,
      meta: {
        breadcrumb: [
          { name: 'Главная', link: '/' },
          { name: 'Медиацентр' }
        ]
      }
    },
    {
      path: '/mediacenter/about',
      component: About,
      meta: {
        breadcrumb: [
          { name: 'Главная', link: '/' },
          { name: 'Медиацентр', link: '/mediacenter' },
          { name: 'О нас' }
        ]
      }
    },
    {
      path: '/mediacenter/news',
      component: News,
      meta: {
        breadcrumb: [
          { name: 'Главная', link: '/' },
          { name: 'Медиацентр', link: '/mediacenter' },
          { name: 'Новости' }
        ]
      }
    },
    {
      path: '/mediacenter/news/news-inner',
      component: NewsInner,
      meta: {
        breadcrumb: [
          { name: 'Главная', link: '/' },
          { name: 'Медиацентр', link: '/mediacenter' },
          { name: 'Новости', link: '/mediacenter/news' },
          { name: 'BelkaCar начинает работать в Сочи' }
        ]
      }
    },
    {
      path: '/mediacenter/brand',
      component: Brand,
      meta: {
        breadcrumb: [
          { name: 'Главная', link: '/' },
          { name: 'Медиацентр', link: '/mediacenter' },
          { name: 'Наш бренд' }
        ]
      }
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js